"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70814,55756],{

/***/ 4377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69428);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54392);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 30px;\n  border-left: 0;\n  border-right: 0;\n  border-color: ",
        " !important;\n  box-shadow: unset !important;\n\n  input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    display: flex;\n    border: unset;\n    width: 100%;\n    background: unset;\n    justify-content: space-between;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    right: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-left: 0;\n    border-radius: 0 2px 2px 0;\n\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    left: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-right: 0;\n    border-radius: 2px 0 0 2px;\n\n    span {\n      display: none !important;\n      border: unset;\n    }\n\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down:hover {\n    height: 32px !important;\n  }\n\n  .ant-input-number-handler,\n  .ant-input-number-handler-wrap:hover .ant-input-number-handler {\n    background: ",
        ";\n    height: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    formatter: function(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parser: function(value) {
        return value.replace(/\s?|(,*)/g, "");
    }
}).withConfig({
    componentId: "sc-d36ac3ab-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .plusIcon */ .R7, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .minusIcon */ .$s, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue));


/***/ }),

/***/ 56371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ trackOrderDetailShareSelected; },
/* harmony export */   "J4": function() { return /* binding */ trackShareSelected; },
/* harmony export */   "M1": function() { return /* binding */ trackOrderShareSelected; },
/* harmony export */   "cP": function() { return /* binding */ trackTradeSharedViewed; },
/* harmony export */   "g3": function() { return /* binding */ trackOrderViewed; },
/* harmony export */   "tE": function() { return /* binding */ trackDoneSelected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56644);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2078);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);




var _obj;
var orderActionValue = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .iX.Buy, "Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .iX.Sell, "Sell"), _obj);
var _obj1;
var symbolTypeValue = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Right */ .Z.Right, "Right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Waran */ .Z.Waran, "Warrant"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Saham */ .Z.Saham, "Normal"), _obj1);
var _obj2;
var expiryValue = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good for day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good till canceled"), _obj2);
var _obj3;
var statusValue = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Open */ .iF.Open, "Open"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Partial */ .iF.Partial, "Partial"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Match */ .iF.Match, "Match"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Withdrawn */ .iF.Withdrawn, "Withdrawn"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Amended */ .iF.Amended, "Amended"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Rejected */ .iF.Rejected, "Rejected"), _obj3);
// Views
var trackOrderViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Order Viewed");
};
var trackTradeSharedViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Trade Shared Viewed");
};
var trackOrderShareSelected = function(type, symbol) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Share Selected"), {
        Action: "".concat(action, " Order Share Selected"),
        Symbol: symbol
    });
};
// Actions
var trackOrderDetailShareSelected = function(type, orderId, symbol, symbolType, expiry, rejectReason, status) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Detail Share Selected"), {
        Action: "".concat(action, " Order Detail Share Selected"),
        "Order ID": orderId,
        Symbol: symbol,
        "Symbol Type": symbolTypeValue[symbolType] || "Normal",
        Expiry: expiryValue[expiry],
        "Reject Reason": rejectReason,
        Status: statusValue[status]
    });
};
var trackShareSelected = function(symbol, isAddAutoShare) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Share Selected",
        Symbol: symbol,
        "Add Auto Share": isAddAutoShare
    });
};
var trackDoneSelected = function(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Done Selected",
        Symbol: symbol
    });
};


/***/ }),

/***/ 77064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    isVisible: false,
    selectedUsers: {},
    sharedUsers: {},
    orderType: undefined,
    expiry: undefined,
    isDayTrade: false
};
var useShareTradeModal = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setIsVisible: function(isVisible) {
            set({
                isVisible: isVisible
            });
        },
        setSelectedUsers: function(selectedUsers) {
            set({
                selectedUsers: selectedUsers
            });
        },
        setSharedUsers: function(sharedUsers) {
            set({
                sharedUsers: sharedUsers
            });
        },
        setOrderType: function(orderType) {
            set({
                orderType: orderType
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setIsDayTrade: function(isDayTrade) {
            set({
                isDayTrade: isDayTrade
            });
        },
        resetShareTradeModal: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeModal);


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_4__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 55756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);



/**
 * Convert price string to integer
 * Handles: "2,700" -> 2700, "-" -> undefined, 2700 -> 2700
 */ var convertPriceToNumber = function(priceInput) {
    if (priceInput === undefined || priceInput === null) {
        return undefined;
    }
    if (typeof priceInput === "number") {
        return priceInput;
    }
    if (priceInput === "-" || !priceInput) {
        return undefined;
    }
    // Remove comma separator and convert to number
    var cleanPrice = priceInput.replace(/,/g, "");
    var parsedPrice = parseInt(cleanPrice, 10);
    return Number.isNaN(parsedPrice) ? undefined : parsedPrice;
};
var useOrderQueueStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        visible: false,
        symbol: "",
        price: undefined,
        action: "BUY",
        orderId: undefined,
        status: undefined,
        pendingOrderData: undefined,
        showModal: function(data) {
            // Check if user has trading account
            var ref = global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState(), accountType = ref.accountType, accessToken = ref.accessToken;
            var isLoggedIn = !!accessToken;
            // Case 1: User doesn't have any trading account -> Show RegisterTradingModal
            // Only check this if we have explicit info that user has no account
            if (accountType && accountType !== global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL && accountType !== global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL) {
                __webpack_require__.e(/* import() */ 70175).then(__webpack_require__.bind(__webpack_require__, 70175)).then(function(param) {
                    var useAuthModalStore = param.default;
                    useAuthModalStore.getState().showModal();
                });
                return;
            }
            // Case 2: User has trading account but not logged in -> Show LoginTradingModal
            // This handles both: accountType === null (haven't checked yet) and logged in but no token
            if (!isLoggedIn) {
                // Store the order queue data for later use
                set({
                    pendingOrderData: data,
                    visible: false
                });
                __webpack_require__.e(/* import() */ 70175).then(__webpack_require__.bind(__webpack_require__, 70175)).then(function(param) {
                    var useAuthModalStore = param.default;
                    useAuthModalStore.getState().showModal({
                        onRealLoginSuccess: function() {
                            // After successful login, proceed with showing order queue
                            setTimeout(function() {
                                var currentState = get();
                                if (currentState.pendingOrderData) {
                                    // Use the stored data to show modal
                                    var price = convertPriceToNumber(currentState.pendingOrderData.price);
                                    // Close TransactionMFModal when order queue modal opens
                                    __webpack_require__.e(/* import() */ 70362).then(__webpack_require__.bind(__webpack_require__, 70362)).then(function(param) {
                                        var tradingModalStore = param.default;
                                        var tradingModalState = tradingModalStore.getState();
                                        if (tradingModalState.onClose) {
                                            tradingModalState.onClose();
                                        }
                                        tradingModalStore.getState().resetModal();
                                    });
                                    set({
                                        visible: true,
                                        symbol: currentState.pendingOrderData.symbol,
                                        price: price,
                                        action: currentState.pendingOrderData.action,
                                        orderId: currentState.pendingOrderData.orderId,
                                        status: currentState.pendingOrderData.status,
                                        pendingOrderData: undefined
                                    });
                                }
                            }, 100);
                        }
                    });
                });
                return;
            }
            // Case 3: User has trading account and is logged in -> Show OrderQueueModal
            var price = convertPriceToNumber(data.price);
            // Close TransactionMFModal when order queue modal opens
            __webpack_require__.e(/* import() */ 70362).then(__webpack_require__.bind(__webpack_require__, 70362)).then(function(param) {
                var tradingModalStore = param.default;
                var tradingModalState = tradingModalStore.getState();
                if (tradingModalState.onClose) {
                    tradingModalState.onClose();
                }
                tradingModalStore.getState().resetModal();
            });
            set({
                visible: true,
                symbol: data.symbol,
                price: price,
                action: data.action,
                orderId: data.orderId,
                status: data.status
            });
        },
        hideModal: function() {
            set({
                visible: false,
                symbol: "",
                price: undefined,
                action: "BUY",
                orderId: undefined,
                status: undefined,
                pendingOrderData: undefined
            });
        },
        reset: function() {
            set({
                visible: false,
                symbol: "",
                price: undefined,
                action: "BUY",
                orderId: undefined,
                status: undefined,
                pendingOrderData: undefined
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["default"] = (useOrderQueueStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "Gd": function() { return /* binding */ checkIsCancelable; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "v1": function() { return /* binding */ checkIsAmendable; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
/* harmony import */ var global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6421);

var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            return filterFn(i.gtc_text, expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};
var SMART_ORDER_LABELS = new Set([
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.SL */ .D0.SL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TP */ .D0.TP,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.TS */ .D0.TS,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.AB */ .D0.AB,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.LIT_SELL */ .D0.LIT_SELL,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.BO */ .D0.BO,
    global_Securities_types_trading__WEBPACK_IMPORTED_MODULE_0__/* .SmartOrderLabel.VTO */ .D0.VTO, 
]);
var isSmartOrder = function(label) {
    return SMART_ORDER_LABELS.has(label);
};
var checkIsCancelable = function(item) {
    return isSmartOrder(item.label) ? item.cancel_target !== "ACTION_TARGET_UNSPECIFIED" : item.cancel_action;
};
var checkIsAmendable = function(item) {
    return isSmartOrder(item.label) ? item.amend_target !== "ACTION_TARGET_UNSPECIFIED" : item.amend_action;
};



/***/ }),

/***/ 21455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export TradingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TradingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    tradingStore: null
});
/* harmony default export */ __webpack_exports__["Z"] = (TradingContext);


/***/ }),

/***/ 207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/transaction/store.ts



var initialState = {
    openModal: "",
    symbol: null,
    orderType: null,
    formType: null,
    openFromWidget: false
};
var tradingStore = function() {
    return (0,esm/* default */.ZP)(function(set) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
            setModal: function(modal, payload) {
                set((0,_object_spread/* default */.Z)({
                    openModal: modal
                }, payload));
            },
            resetModal: function() {
                set(initialState);
            },
            setSymbol: function(symbol) {
                set({
                    symbol: symbol
                });
            },
            setOrderType: function(type) {
                set({
                    orderType: type
                });
            },
            setFormType: function(type) {
                set({
                    formType: type
                });
            },
            setOpenFromWidget: function(open) {
                set({
                    openFromWidget: open
                });
            },
            setAutoOrderId: function(autoOrderId) {
                set({
                    autoOrderId: autoOrderId
                });
            }
        });
    });
};
/* harmony default export */ var store = (tradingStore);

// EXTERNAL MODULE: ./src/features/transaction/context.tsx
var context = __webpack_require__(21455);
;// CONCATENATED MODULE: ./src/features/transaction/provider.tsx




var TradingContextProvider = function(param) {
    var children = param.children;
    var formValuesContext = (0,react.useMemo)(function() {
        return {
            tradingStore: store()
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: formValuesContext,
        children: children
    });
};
/* harmony default export */ var provider = (TradingContextProvider);


/***/ }),

/***/ 27607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SkeletonWrapper = function(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, skeleton = param.skeleton, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? skeleton : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonWrapper);


/***/ }),

/***/ 8992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ securitiesStorageKey; }
/* harmony export */ });
var securitiesStorageKey = {
    tradeIsLogin: "tradeIsLogin",
    accessToken: "securitiesAccessToken",
    refreshToken: "securitiesRefreshtoken",
    targetAPI: "securitiesTarget",
    stockbitFormula: "formulaStockbit"
};


/***/ }),

/***/ 6421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ SmartOrderLabel; },
/* harmony export */   "ax": function() { return /* binding */ ORDER_TYPE_VALUE_TEXT; },
/* harmony export */   "by": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "n5": function() { return /* binding */ TradingFeatureEnum; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TradingFeatureEnum;
(function(TradingFeatureEnum) {
    TradingFeatureEnum["UNSPECIFIED"] = "FEATURE_UNSPECIFIED";
    TradingFeatureEnum["DAY_TRADE"] = "FEATURE_DAY_TRADE";
    TradingFeatureEnum["SPLIT_ORDER"] = "FEATURE_SPLIT_ORDER";
})(TradingFeatureEnum || (TradingFeatureEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventTypeEnum["OUTSIDE_MARKET_HOURS"] = "EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS";
    EventTypeEnum["EXCEED_DEBT_RATIO"] = "EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO";
})(EventTypeEnum || (EventTypeEnum = {}));
var SmartOrderLabel;
(function(SmartOrderLabel) {
    SmartOrderLabel["TP"] = "TP";
    SmartOrderLabel["SL"] = "SL";
    SmartOrderLabel["MO"] = "MO";
    SmartOrderLabel["TS"] = "TS";
    SmartOrderLabel["AB"] = "AB";
    SmartOrderLabel["BO"] = "BO";
    SmartOrderLabel["LIT_SELL"] = "LIT_SELL";
    SmartOrderLabel["VTO"] = "VTO";
})(SmartOrderLabel || (SmartOrderLabel = {}));
var _obj;
var ORDER_TYPE_VALUE_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TP, "Take Profit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.SL, "Stop Loss"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.TS, "Trailing Stop"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.AB, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.LIT_SELL, "Limit If Touched"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.BO, "Bracket Limit Order"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SmartOrderLabel.MO, "Market Order"), _obj);


/***/ }),

/***/ 98202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ getSellAmountInvestedFee; },
/* harmony export */   "J0": function() { return /* binding */ getLimitLot; },
/* harmony export */   "Oz": function() { return /* binding */ generateUpdatedPortfolioHeader; },
/* harmony export */   "Sd": function() { return /* binding */ getSellGain; },
/* harmony export */   "fY": function() { return /* binding */ getProfitLoss; },
/* harmony export */   "jm": function() { return /* binding */ generateUpdatedPortfolioItem; },
/* harmony export */   "yq": function() { return /* binding */ getBuyAmountInvested; }
/* harmony export */ });
/* unused harmony exports getConfigFormula, getBuyAmountInvestedFee */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _constants_localStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8992);
/* eslint-disable no-new-func */ 

var getConfigFormula = function() {
    var ref;
    return ((ref = JSON.parse(localStorage.getItem(_constants_localStorage__WEBPACK_IMPORTED_MODULE_0__/* .securitiesStorageKey.stockbitFormula */ .O.stockbitFormula))) === null || ref === void 0 ? void 0 : ref.formula) || {};
};
var getSellAmountInvestedFee = function(lot, price, isCorporateAction) {
    var isDayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref = getConfigFormula(), sellAmountInvestedFee = ref.sell_amount_invested_fee, caSellAmountInvestedFee = ref.ca_sell_amount_invested_fee, feeSell = ref.fee_sell, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade, feeSellDayTrade = ref.fee_sell_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    var FEE_SELL = isDayTrade ? feeSellDayTrade : feeSell;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",").concat(isCorporateAction ? "FEE_BUY=".concat(FEE_BUY) : "FEE_SELL=".concat(FEE_SELL)), "return ".concat(isCorporateAction ? caSellAmountInvestedFee : sellAmountInvestedFee))();
};
var getBuyAmountInvested = function(lot, price) {
    var ref = getConfigFormula(), buyAmountInvested = ref.buy_amount_invested;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(buyAmountInvested))();
};
var getBuyAmountInvestedFee = function(lot, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref = getConfigFormula(), buyAmountInvestedFee = ref.buy_amount_invested_fee, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",FEE_BUY=").concat(FEE_BUY), "return ".concat(buyAmountInvestedFee))();
};
var getProfitLoss = function(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellProfitLoss = ref.sell_profit_loss;
    return new Function("SELL_AMOUNT_INVESTED_FEE=".concat(sellAmountInvestedFee, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellProfitLoss))();
};
var getSellGain = function(sellProfitLoss, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellGain = ref.sell_gain;
    return new Function("SELL_PROFITLOSS=".concat(sellProfitLoss, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellGain))() * 100;
};
var getLimitLot = function(balance, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var priceWithFee = getBuyAmountInvestedFee(1, price, isDayTrade);
    var limitLot = Math.floor(balance / priceWithFee);
    return limitLot < 0 ? 0 : limitLot;
};
var generateUpdatedPortfolioItem = function(configFormula, lastPrice, balanceLot, amountInvested) {
    var formula = (configFormula !== null && configFormula !== void 0 ? configFormula : {
        formula: getConfigFormula()
    }).formula;
    var LOT = balanceLot;
    var CURRENT_PRICE = lastPrice;
    var AMOUNT_INVESTED = amountInvested;
    var unrealised_market_value = new Function("LOT", "CURRENT_PRICE", "return ".concat(formula.unrealised_market_value, ";"))(LOT, CURRENT_PRICE);
    var UNREALISED_MARKET_VALUE = unrealised_market_value;
    var unrealised_profit_loss = new Function("UNREALISED_MARKET_VALUE", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_profit_loss, ";"))(UNREALISED_MARKET_VALUE, AMOUNT_INVESTED);
    var UNREALISED_PROFIT_LOSS = unrealised_profit_loss;
    var unrealised_gain = new Function("UNREALISED_PROFIT_LOSS", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_gain, ";"))(UNREALISED_PROFIT_LOSS, AMOUNT_INVESTED);
    return {
        unrealised_marketvalue: unrealised_market_value,
        unrealised_profitloss: unrealised_profit_loss,
        unrealised_gain: unrealised_gain
    };
};
var generateUpdatedPortfolioHeader = function(configFormula) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], tradingBalance = arguments.length > 3 ? arguments[3] : void 0, amountInvested = arguments.length > 4 ? arguments[4] : void 0, amountAllocated = arguments.length > 5 ? arguments[5] : void 0, totalDebt = arguments.length > 6 ? arguments[6] : void 0;
    var formula = (configFormula !== null && configFormula !== void 0 ? configFormula : {
        formula: getConfigFormula()
    }).formula;
    var combinedResult = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(result).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dayTrade));
    var unrealised_profitloss = combinedResult.reduce(function(sum, item) {
        return item.unrealised_profitloss !== undefined ? sum + item.unrealised_profitloss : sum;
    }, 0);
    var SUMMARY_NET_PROFIT_LOSS = unrealised_profitloss;
    var TRADING_BALANCE = tradingBalance;
    var SUMMARY_OPEN = amountAllocated;
    var SUMMARY_INVESTED = amountInvested;
    var gain = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_net_profit_loss_percentage, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var equity = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_equity, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var unrealised_market_value_day_trade = dayTrade.reduce(function(sum, item) {
        return item.unrealised_marketvalue !== undefined ? sum + item.unrealised_marketvalue : sum;
    }, 0);
    var TOTAL_DEBT = totalDebt;
    var DAY_TRADE_MARKET_VALUE = unrealised_market_value_day_trade;
    var ratio = new Function("TOTAL_DEBT", "DAY_TRADE_MARKET_VALUE", "return ".concat(formula.day_trade_debt_ratio, ";"))(TOTAL_DEBT, DAY_TRADE_MARKET_VALUE);
    return {
        unrealised_profitloss: unrealised_profitloss,
        gain: gain,
        equity: equity,
        ratio: ratio * 100,
        market_value: DAY_TRADE_MARKET_VALUE
    };
};


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 86408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ getFormula; },
  "u": function() { return /* binding */ postCancel; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/config.ts
var configEndpoint = {
    formula: "/virtualtrading/config/formula",
    cancel: "/virtualtrading/cancel"
};
/* harmony default export */ var config = (configEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/config.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getFormula = function() {
    return defaultInstance.get(config.formula);
};
var postCancel = function(requestBody) {
    return defaultInstance.post(config.cancel, requestBody);
};


/***/ }),

/***/ 79397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cf": function() { return /* binding */ getVirtualOrderList; },
  "__": function() { return /* binding */ postVirtualAmendOrder; },
  "$C": function() { return /* binding */ postVirtualOrder; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/order.ts
var orderEndpoints = {
    list: function() {
        return "/virtualtrading/order";
    },
    create: function(type, symbol) {
        return "/virtualtrading/".concat(type, "/").concat(symbol);
    },
    amend: function() {
        return "/virtualtrading/amend";
    }
};
/* harmony default export */ var order = (orderEndpoints);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/order.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getVirtualOrderList = function() {
    return defaultInstance.get(order.list());
};
var postVirtualOrder = function(orderType, symbol, payload) {
    return defaultInstance.post(order.create(orderType, symbol), payload);
};
var postVirtualAmendOrder = function(payload) {
    return defaultInstance.post(order.amend(), payload);
};


/***/ }),

/***/ 80943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ getPortfolioDetail; },
  "g": function() { return /* binding */ getPortfolioList; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/portfolio.ts
var portfolioEndpoint = {
    detail: function(symbol) {
        return "/virtualtrading/portfolio/".concat(symbol);
    },
    list: function() {
        return "/virtualtrading/portfolio";
    }
};
/* harmony default export */ var portfolio = (portfolioEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/portfolio.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getPortfolioDetail = function(symbol) {
    return defaultInstance.get(portfolio.detail(symbol));
};
var getPortfolioList = function() {
    return defaultInstance.get(portfolio.list());
};


/***/ }),

/***/ 47002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36902);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);




var useGetPortfolioData = function(symbol) {
    var refetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, fromAll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, dayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading;
    var ref1 = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), _portfolio = ref1.portfolio, _data = _portfolio.data, realList = _data.result, _portfolioDetail = ref1.portfolioDetail, detail = _portfolioDetail.data, _portfolioDetailDayTrade = ref1.portfolioDetailDayTrade, detailDayTrade = _portfolioDetailDayTrade.data, getPortfolio = ref1.getPortfolio, getPortfolioDetail = ref1.getPortfolioDetail;
    var data = null;
    if (symbol) {
        if (isRealTrading && symbol) {
            if (fromAll) {
                data = realList.find(function(l) {
                    return l.symbol === symbol;
                });
            } else {
                data = dayTrade ? detailDayTrade : detail;
            }
        } else if (isVirtualTrading) {
            data = realList.find(function(l) {
                return l.symbol === symbol;
            });
        }
    } else {
        data = realList;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (refetch) {
            if (isRealTrading && !symbol) {
                getPortfolio(true, !router.asPath.includes("portfolio") && !router.asPath.includes("chartbit"));
            } else if (isRealTrading && symbol) {
                getPortfolioDetail(symbol);
            }
            if (isVirtualTrading) getPortfolio(false);
        }
    }, [
        symbol,
        refetch
    ]);
    return data || {};
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetPortfolioData);


/***/ }),

/***/ 66959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ trackAutoBuyOrderReceivedView; },
/* harmony export */   "FY": function() { return /* binding */ trackAutoBuyOrderConfirmed; },
/* harmony export */   "Fs": function() { return /* binding */ trackAutoBuyDetailView; },
/* harmony export */   "GK": function() { return /* binding */ trackAutoSellAlterOrderView; },
/* harmony export */   "HJ": function() { return /* binding */ trackAutoSellAlterOrderSelected; },
/* harmony export */   "Jl": function() { return /* binding */ trackAutoSellOrderTypeSelected; },
/* harmony export */   "K": function() { return /* binding */ trackAutoSellOrderCanceled; },
/* harmony export */   "PH": function() { return /* binding */ trackAutoBuyOrderView; },
/* harmony export */   "Pz": function() { return /* binding */ trackAutoSellOrderDeleted; },
/* harmony export */   "RI": function() { return /* binding */ trackAutoSellOrderConfirmed; },
/* harmony export */   "Rj": function() { return /* binding */ trackAutoBuyOrderDone; },
/* harmony export */   "V0": function() { return /* binding */ trackAutoSellInfoSelected; },
/* harmony export */   "Vf": function() { return /* binding */ trackAutoSellDeleteCanceled; },
/* harmony export */   "ZY": function() { return /* binding */ trackAutoBuyTriggerConditionSelected; },
/* harmony export */   "_3": function() { return /* binding */ trackAutoBuyConfirmOrderCanceled; },
/* harmony export */   "_E": function() { return /* binding */ trackAutoBuyOrderTypeInfoSelected; },
/* harmony export */   "bG": function() { return /* binding */ trackAutoSellOrderQuantityAdjusted; },
/* harmony export */   "bm": function() { return /* binding */ trackAutoSellOrderSelected; },
/* harmony export */   "dM": function() { return /* binding */ trackAutoBuyOrderTypeSelected; },
/* harmony export */   "fY": function() { return /* binding */ trackAutoBuyOrderCanceled; },
/* harmony export */   "fh": function() { return /* binding */ trackAutoSellOrderInfoClosed; },
/* harmony export */   "gT": function() { return /* binding */ trackAutoBuyTriggerPriceInfoSelected; },
/* harmony export */   "i7": function() { return /* binding */ trackAutoSellFormView; },
/* harmony export */   "iY": function() { return /* binding */ trackAutoOrderCanceled; },
/* harmony export */   "jU": function() { return /* binding */ trackAutoBuyPreviewOrderView; },
/* harmony export */   "pR": function() { return /* binding */ trackAutoBuyOrderPlaced; },
/* harmony export */   "ur": function() { return /* binding */ trackAutoSellAutoOrderView; },
/* harmony export */   "vD": function() { return /* binding */ trackAutoSellInfoView; }
/* harmony export */ });
/* unused harmony exports trackAutoBuyAction, trackAutoBuyTncSelected, trackAutoBuyCancelOrderSelected, trackAutoBuyAmendSelected, trackAutoSellDetailOrderView, trackAutoSellOrderDetailClosed, trackAutoSellOrderTncSelected */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var trackAutoBuyOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Viewed");
};
var trackAutoBuyPreviewOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Previewed");
};
var trackAutoBuyOrderReceivedView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Received Viewed");
};
var trackAutoBuyDetailView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Order Detail Viewed");
};
var trackAutoBuyAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Action", eventObject);
};
var trackAutoBuyOrderTypeSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Set Order Type Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTriggerPriceInfoSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Price Info Selected"
    });
};
/**
 *
 * @param {('≥' | '≤')} condition
 * @returns
 */ var trackAutoBuyTriggerConditionSelected = function(condition) {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Condition Selected",
        Condition: condition
    });
};
var trackAutoBuyOrderTypeInfoSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Order Type Info Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTncSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Smart Order Terms & Conditions Selected"
    });
};
var trackAutoBuyOrderCanceled = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Order Buy Canceled"
    });
};
var trackAutoBuyOrderPlaced = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Placed"
    });
};
var trackAutoBuyConfirmOrderCanceled = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Canceled",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderConfirmed = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Confirmed",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderDone = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Done"
    });
};
var trackAutoBuyCancelOrderSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Cancel Order Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyAmendSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Amend Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
// #endregion Auto Buy
// #region Auto Sell
var trackAutoSellAutoOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Auto Order Viewed");
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellFormView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Viewed"));
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellInfoView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Information Viewed"));
};
var trackAutoSellDetailOrderView = function() {
    clevertapEvent("Auto Sell Detail Auto Order Viewed");
};
/**
 *
 * @param {("Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Auto Order Viewed"));
};
var trackAutoSellAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Action", eventObject);
};
/**
 *
 * @param {string} stock
 */ var trackAutoSellOrderSelected = function(stock) {
    trackAutoSellAction({
        Action: "Auto Sell Set Auto Order Selected",
        Stock: stock
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 */ var trackAutoSellOrderTypeSelected = function(type, stock) {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Type Selected",
        "Auto Sell Type": type,
        Stock: stock
    });
};
var trackAutoOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Canceled"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 */ var trackAutoSellInfoSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Information Selected")
    });
};
var trackAutoSellOrderQuantityAdjusted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Quantity Adjusted"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 * @param {number} lot
 * @param {number} price
 * @param {string} tpPercentage
 * @param {string} slPercentage
 */ var trackAutoSellOrderConfirmed = function(type, stock, lot, price, gainPercentage) {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Confirmed",
        "Auto Sell Type": type,
        Stock: stock,
        Lot: lot,
        Price: price,
        "Take Profit Percentage": type === "Take Profit" ? gainPercentage : 0,
        "Stop Loss Percentage": type === "Stop Loss" ? gainPercentage : 0
    });
};
var trackAutoSellOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Canceled"
    });
};
var trackAutoSellOrderInfoClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Information Closed"
    });
};
var trackAutoSellOrderDetailClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Detail Closed"
    });
};
/**
 *
 * @param {("Add"|"Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Auto Order Selected")
    });
};
var trackAutoSellDeleteCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Delete Canceled"
    });
};
var trackAutoSellOrderDeleted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Deleted"
    });
};
var trackAutoSellOrderTncSelected = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Terms & Conditions Selected"
    });
}; // #endregion Auto Sell


/***/ }),

/***/ 91154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ clevertapDayTradeSortSelected; },
/* harmony export */   "$f": function() { return /* binding */ clevertapExerciseClicked; },
/* harmony export */   "$v": function() { return /* binding */ clevertapDayTradeOrderTypeSelected; },
/* harmony export */   "A2": function() { return /* binding */ clevertapBuyOrderViewed; },
/* harmony export */   "Am": function() { return /* binding */ clevertapDayTradeLeverageSelected; },
/* harmony export */   "As": function() { return /* binding */ clevertapOrderPlaced; },
/* harmony export */   "B0": function() { return /* binding */ clevertapSellOrderViewed; },
/* harmony export */   "C4": function() { return /* binding */ clevertapSetPriceAlertSelected; },
/* harmony export */   "C5": function() { return /* binding */ clevertapDayTradeTNCViewed; },
/* harmony export */   "CH": function() { return /* binding */ clevertapOrderQuantityAdjusted; },
/* harmony export */   "EQ": function() { return /* binding */ clevertapChangeStock; },
/* harmony export */   "F9": function() { return /* binding */ clevertapDayTradeSplitOrderSelected; },
/* harmony export */   "FH": function() { return /* binding */ clevertapSecuritiesTradingPinSubmitted; },
/* harmony export */   "HR": function() { return /* binding */ clevertapDayTradeActivationDismissed; },
/* harmony export */   "J2": function() { return /* binding */ clevertapOrderPreviewed; },
/* harmony export */   "L": function() { return /* binding */ clevertapDayTradeDebtRatioViewed; },
/* harmony export */   "LA": function() { return /* binding */ clevertapViewChartSelected; },
/* harmony export */   "LF": function() { return /* binding */ clevertapExerciseViewed; },
/* harmony export */   "Lx": function() { return /* binding */ clevertapPortfolioDetailExercise; },
/* harmony export */   "Nf": function() { return /* binding */ clevertapDayTradeLeverageOptionViewed; },
/* harmony export */   "Rs": function() { return /* binding */ clevertapOrderTabSelected; },
/* harmony export */   "SW": function() { return /* binding */ clevertapDayTradeDebtRatioSubmitted; },
/* harmony export */   "Sv": function() { return /* binding */ clevertapExchangeFee; },
/* harmony export */   "TD": function() { return /* binding */ clevertapDayTradeDebtRatioChipSelected; },
/* harmony export */   "Uj": function() { return /* binding */ clevertapExerciseSelected; },
/* harmony export */   "V8": function() { return /* binding */ clevertapDayTradeActivationViewed; },
/* harmony export */   "_3": function() { return /* binding */ clevertapOrderDetailAmendViewed; },
/* harmony export */   "_O": function() { return /* binding */ clevertapPortfolioCompanySell; },
/* harmony export */   "_h": function() { return /* binding */ clevertapDayTradeOrderDetailSelected; },
/* harmony export */   "bQ": function() { return /* binding */ clevertapOrderCanceled; },
/* harmony export */   "dQ": function() { return /* binding */ clevertapOrderReceived; },
/* harmony export */   "f0": function() { return /* binding */ clevertapPortfolioBuyMore; },
/* harmony export */   "fn": function() { return /* binding */ clevertapSecuritiesTradingPinViewed; },
/* harmony export */   "hA": function() { return /* binding */ clevertapOrderDetailCancelConfirmed; },
/* harmony export */   "in": function() { return /* binding */ clevertapOrderViewed; },
/* harmony export */   "jS": function() { return /* binding */ clevertapDayTradeAfterMarketViewed; },
/* harmony export */   "kt": function() { return /* binding */ clevertapOrderDetailViewed; },
/* harmony export */   "lH": function() { return /* binding */ clevertapDayTradeActivationSelected; },
/* harmony export */   "mD": function() { return /* binding */ clevertapPortfolioSell; },
/* harmony export */   "mf": function() { return /* binding */ clevertapOrderDetailCancel; },
/* harmony export */   "ng": function() { return /* binding */ clevertapSetVisibleBalance; },
/* harmony export */   "oZ": function() { return /* binding */ clevertapDayTradeLeverageActivationSelected; },
/* harmony export */   "p": function() { return /* binding */ clevertapDayTradeActivationSuccessSelected; },
/* harmony export */   "pl": function() { return /* binding */ clevertapDayTradeActivationSubmitted; },
/* harmony export */   "qj": function() { return /* binding */ clevertapPortfolioDetailViewed; },
/* harmony export */   "r8": function() { return /* binding */ clevertapAutoOrderOptionsViewed; },
/* harmony export */   "rP": function() { return /* binding */ clevertapDayTradeStockListViewed; },
/* harmony export */   "sW": function() { return /* binding */ clevertapExerciseError; },
/* harmony export */   "t3": function() { return /* binding */ clevertapDayTradeDebtRatioModalViewed; },
/* harmony export */   "tG": function() { return /* binding */ clevertapPortfolioOrderViewed; },
/* harmony export */   "v8": function() { return /* binding */ clevertapOrderDone; },
/* harmony export */   "vM": function() { return /* binding */ clevertapStockSelected; },
/* harmony export */   "xA": function() { return /* binding */ clevertapOrderDetailAmend; },
/* harmony export */   "xC": function() { return /* binding */ clevertapBuyError; },
/* harmony export */   "xh": function() { return /* binding */ clevertapOrderConfirmedSuccess; },
/* harmony export */   "xs": function() { return /* binding */ clevertapDayTradeActivationSuccessViewed; },
/* harmony export */   "y8": function() { return /* binding */ clevertapOrderConfirmed; },
/* harmony export */   "yr": function() { return /* binding */ clevertapPortfolioViewed; }
/* harmony export */ });
/* unused harmony exports generateSymbolType, clevertapTransactionOrderFailed, clevertapTransactionOrderFailedConfirmed, clevertapTransactionOrderAlert, clevertapBuyStockContinue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42227);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29097);
/* harmony import */ var _virtualTrading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29351);
// List of clevertap event for stockbit securities
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
// Clevertap event is wrapped with high order function
// to separate concern with existing code.








// Symbol type for clevertap is different from
// exisitng API response
function generateSymbolType(symbol) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol.split("-"), 2), symbolType = ref[1];
    if (!symbolType) {
        return "Normal";
    }
    if (symbolType.toUpperCase()[0] === "R") {
        return "Right";
    }
    if (symbolType.toUpperCase()[0] === "W") {
        return "Warrant";
    }
    return "";
}
function clevertapOrderDetailCancel() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", orderType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Buy";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_SELECTED */ .Le, {
        Type: type,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_VIEWED */ .Tf);
}
function clevertapOrderDetailCancelConfirmed(param) {
    var symbol = param.symbol, orderType = param.orderType, expiry = param.expiry, leverage = param.leverage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_CONFIRMED */ .fR, {
        symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Expiry: expiry,
        "Leverage Type": leverage
    });
}
function clevertapOrderDetailAmend(param) {
    var _type = param.type, type = _type === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _type, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_AMEND_SELECTED */ .fg, {
        Type: type,
        symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapOrderDetailAmendViewed(param) {
    var symbol = param.symbol, orderType = param.orderType, type = param.type;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_VIEWED */ .z8, {
        Symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Type: type
    });
}
function clevertapOrderQuantityAdjusted(param) {
    var symbol = param.symbol, orderType = param.orderType, adjustedType = param.adjustedType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_QUANTITY_ADJUSTED */ .gW,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_QUANTITY_ADJUSTED */ .sR,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPlaced(param) {
    var orderType = param.orderType, symbol = param.symbol, price = param.price, lot = param.lot, gainLoss = param.gainLoss, totalLot = param.totalLot, tradingBalancePercentage = param.tradingBalancePercentage, status = param.status, expiry = param.expiry, type = param.type, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PLACED */ .gg,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "% Trading Balance": tradingBalancePercentage,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PLACED */ .vc,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "Gain/Loss %": gainLoss,
            "% Total Lot": totalLot,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPreviewed(param) {
    var symbol = param.symbol, orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PREVIEWED */ .L9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PREVIEWED */ .q7,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_PREVIEWED */ .jG,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderCanceled(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CANCELED */ .lE,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CANCELED */ .dT,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CANCELED */ .a,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmed(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED */ .ee,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED */ .ZF,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type,
            Expiry: expiry,
            "Balance Lot": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CONFIRMED */ .Dn,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmedSuccess(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderId = param.orderId, orderType = param.orderType, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry;
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (currentUrl.includes("symbol")) {
        if (currentUrl.includes("chartbit")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
        } else {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
        }
    } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
    } else if (currentUrl.includes("portfolio")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
    } else if (currentUrl.includes("watchlist")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
    }
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED_SUCCESS */ .p3,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED_SUCCESS */ .LD,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderReceived(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_RECEIVED */ .Hm,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_RECEIVED */ .n2,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderDone(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_DONE */ .g1,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_DONE */ .xc,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapExchangeFee(orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_SELECTED */ .tI);
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_VIEWED */ ._e, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
}
function clevertapChangeStock() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_STOCK_VIEWED */ .jr);
}
function clevertapBuyError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ERROR_PAGE */ .IU, {
        Reason: "Insufficient Trading Limit"
    });
}
function clevertapPortfolioSell(param) {
    var _tradingType = param.tradingType, tradingType = _tradingType === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _tradingType, source = param.source, gainLoss = param.gainLoss, symbol = param.symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SELL_STOCK_SELECTED */ .vf, {
        Type: tradingType,
        Source: source,
        "Gain/Loss %": gainLoss,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioCompanySell(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_COMPANY_SELL_STOCK_SELECTED */ .JW, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioBuyMore(symbol, gainLoss) {
    var tradingType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_BUY_MORE_SELECTED */ ._O, {
        Symbol: symbol,
        "Gain / Loss %": gainLoss,
        Type: tradingType
    });
}
function clevertapViewChartSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEW_CHART_SELECTED */ .J1, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapSetPriceAlertSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SET_PRICE_ALERT_SELECTED */ .ef, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapPortfolioViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, portfolioType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .PORTFOLIOS_TYPE.regular */ .ub.regular;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEWED */ .tA, {
        Type: tradingType,
        "Portfolio List": portfolioType
    });
}
function clevertapPortfolioOrderViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Order";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_ORDER_VIEWED */ .zF, {
        Type: tradingType,
        Filter: (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(filter)
    });
}
function clevertapOrderViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_VIEWED */ .dz);
}
function clevertapOrderDetailViewed(param) {
    var orderType = param.orderType, status = param.status, rejectReason = param.rejectReason, expiry = param.expiry, symbol = param.symbol, type = param.type, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _dayTradeForceSell = param.dayTradeForceSell, dayTradeForceSell = _dayTradeForceSell === void 0 ? false : _dayTradeForceSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_VIEWED */ .v9, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        Status: status,
        "Reject Reason": rejectReason,
        Expiry: expiry,
        Symbol: symbol,
        Type: type,
        "Symbol Type": generateSymbolType(symbol),
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": dayTradeForceSell ? "Force Sell" : "Regular"
    });
}
function clevertapStockSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_SELECTED */ .B);
}
function clevertapExerciseClicked(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_EXERCISE_CLICKED */ ._g, {
        Symbol: symbol
    });
}
function clevertapExerciseViewed(param) {
    var symbol = param.symbol, share = param.share;
    return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_VIEWED */ .dW, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share
    });
}
function clevertapExerciseSelected(param) {
    var symbol = param.symbol, share = param.share, stockOnHandPercentage = param.stockOnHandPercentage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_SELECTED */ .Nq, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share,
        "% Stock on Hand": stockOnHandPercentage
    });
}
function clevertapExerciseError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ERROR_PAGE */ .Vm, {
        Reason: "Melebihi Cash on Hand"
    });
}
function clevertapTransactionOrderFailed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED);
}
function clevertapTransactionOrderFailedConfirmed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED_CONFIRMED);
}
function clevertapTransactionOrderAlert() {
    clevertapEvent(TRANSACTION_ORDER_ALERT);
}
function clevertapBuyStockContinue() {
    clevertapEvent(BUY_STOCK_CONTINUE);
}
function clevertapPortfolioDetailViewed(param) {
    var symbol = param.symbol, gainLoss = param.gainLoss, exerciseable = param.exerciseable, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_STOCK_DETAIL_VIEWED */ .kC, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Gain/Loss %": gainLoss,
        Exercisable: exerciseable,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular"
    });
}
function clevertapPortfolioDetailExercise(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_DETAIL_EXERCISE_SELECTED */ .le, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapDayTradeActivationViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_VIEWED */ .jY);
}
function clevertapDayTradeTNCViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_TNC_VIEWED */ .hG);
}
function clevertapDayTradeActivationSuccessViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_VIEWED */ .DQ);
}
function clevertapDayTradeActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SELECTED */ .Av
    });
}
function clevertapDayTradeActivationDismissed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_DISMISSED */ .wK
    });
}
function clevertapDayTradeActivationSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUBMITTED */ .mX
    });
}
function clevertapDayTradeActivationSuccessSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_SELECTED */ .Go
    });
}
function clevertapDayTradeLeverageOptionViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_OPTION_VIEWED */ .zW);
}
function clevertapDayTradeLeverageActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED */ .TC
    });
}
function clevertapDayTradeAfterMarketViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_AFTER_MARKET_VIEWED */ .D1);
}
function clevertapDayTradeDebtRatioViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_VIEWED */ .nc);
}
function clevertapDayTradeDebtRatioSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED */ .Yu
    });
}
function clevertapDayTradeDebtRatioChipSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_CHIP_SELECTED */ .zt
    });
}
function clevertapDayTradeDebtRatioModalViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_MODAL_VIEWED */ .bK);
}
function clevertapDayTradeStockListViewed(param) {
    var _sourcePage = param.sourcePage, sourcePage = _sourcePage === void 0 ? "Company Page" : _sourcePage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_LIST_VIEWED */ .GK, {
        "Source Page": sourcePage
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_SORT_VIEWED */ .YM);
}
function clevertapDayTradeLeverageSelected(leverage) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7,
        Leverage: leverage
    });
}
function clevertapDayTradeSortSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_SELECTED */ .cc
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_APPLIED */ .Zy
    });
}
function clevertapDayTradeOrderTypeSelected(stock, orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_TYPE_SELECTED */ .YB,
        Stock: stock,
        "Buy Order Type": orderType
    });
}
function clevertapDayTradeSplitOrderSelected(toggle) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SPLIT_ORDER_SELECTED */ .CV,
        Toggle: toggle ? "On" : "Off"
    });
}
function clevertapDayTradeOrderDetailSelected(param) {
    var symbol = param.symbol, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_DETAIL_SELECTED */ .BY, {
        Symbol: symbol,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": forcedSell ? "Force Sell" : "Regular"
    });
}
function clevertapSecuritiesTradingPinViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_VIEWED */ .Hd);
}
function clevertapSecuritiesTradingPinSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_SUBMITTED */ .II, {
        Method: "PIN Input"
    });
}
function clevertapBuyOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_VIEWED */ .HA, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapSellOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_VIEWED */ .gE, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapAutoOrderOptionsViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_AUTO_ORDER_OPTIONS_VIEWED */ .YS);
}
function clevertapSetVisibleBalance() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SET_VISIBLE_BALANCE */ .G2);
}
function clevertapOrderTabSelected(tab) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Order Detail Action", {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_ORDER_TAB_SELECTED */ .Oc,
        "Transaction Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(tab)
    });
}


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page",
    chartbit: "Chartbit"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 56703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable max-len */ 



var alertURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/alert");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getDataPriceAlert = function(params) {
    return request.get("".concat(alertURL, "/status/active"), {
        params: params
    });
};
var getDataAlertLog = function() {
    var statusNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", opt = arguments.length > 1 ? arguments[1] : void 0;
    var status = statusNumber;
    return request.get("".concat(alertURL), {
        params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, opt), {
            status: status
        })
    });
};
var getDetailAlert = function(alertId) {
    return request.get("".concat(alertURL, "/").concat(alertId));
};
// command is a string of {"stock": [stock], "value": [value], "operator": [opt], "item": "[item]}
var addPriceAlert = function(name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.post("".concat(alertURL), options);
};
var editPriceAlert = function(alertId, name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.put("".concat(alertURL, "/").concat(alertId), options);
};
var cancelPriceAlert = function(id) {
    return request.delete("".concat(alertURL, "/").concat(id));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getDataPriceAlert: getDataPriceAlert,
    getDataAlertLog: getDataAlertLog,
    getDetailAlert: getDetailAlert,
    addPriceAlert: addPriceAlert,
    editPriceAlert: editPriceAlert,
    cancelPriceAlert: cancelPriceAlert
});


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable no-undef */ 


var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
// APIs
var ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// EXODUS APIs
var EXODUS_ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// Should be replaced with get company orderbook data but the exodus endpoint
// doesn't support special symbols e.g. IHSG
var getOrderbookPreviewBySymbol = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/company-price-feed/v2/orderbook/companies/").concat(symbol));
};
var getOrderbookList = function() {
    return requestExodus.get(EXODUS_ORDERBOOK_API);
};
var createOrderbookList = function(param) {
    var orderbookName = param.orderbookName;
    return requestExodus.post(EXODUS_ORDERBOOK_API, {
        name: orderbookName
    });
};
var editOrderbookList = function(param) {
    var id = param.id, orderbookName = param.orderbookName, symbols = param.symbols;
    var params = {
        name: orderbookName
    };
    if (symbols) params.symbols = symbols;
    return requestExodus.put("".concat(EXODUS_ORDERBOOK_API, "/").concat(id), params);
};
var deleteOrderbookList = function(param) {
    var id = param.id;
    return requestExodus.delete("".concat(EXODUS_ORDERBOOK_API, "/").concat(id));
};
var getOrderbookListItem = function(id) {
    if (id) {
        return requestExodus.get("/company-price-feed/v2/orderbook/template/".concat(id));
    }
    // Get default orderbook if ID is not passed
    // Harusnya nantinya ada lebih lanjut terkait ini sih, gimana kalo enggak ada ID nya
    return requestExodus.get(ORDERBOOK_API);
};
var getCompanyInfo = function(symbol) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/").concat(symbol, "/info"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getOrderbookPreviewBySymbol: getOrderbookPreviewBySymbol,
    getOrderbookList: getOrderbookList,
    createOrderbookList: createOrderbookList,
    editOrderbookList: editOrderbookList,
    deleteOrderbookList: deleteOrderbookList,
    getOrderbookListItem: getOrderbookListItem,
    getCompanyInfo: getCompanyInfo
});


/***/ }),

/***/ 59140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ff": function() { return /* binding */ editStopOrder; },
/* harmony export */   "GP": function() { return /* binding */ editSmartOrder; },
/* harmony export */   "Xz": function() { return /* binding */ getStockData; },
/* harmony export */   "sU": function() { return /* binding */ postSmartOrder; },
/* harmony export */   "xB": function() { return /* binding */ postSmartOrderTnC; },
/* harmony export */   "xy": function() { return /* binding */ postStopOrder; },
/* harmony export */   "zW": function() { return /* binding */ smartOrderDelete; }
/* harmony export */ });
/* unused harmony export deleteStopOrder */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48884);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);




var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, true, false);
/**
  * @deprecated Use `postStopOrder` instead
*/ var postSmartOrder = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: [
            payload
        ]
    });
};
var postStopOrder = function(data) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order/stop-order/v1/order"), data);
};
/**
 * @deprecated Use `editStopOrder` instead
 */ var editSmartOrder = function(payload) {
    return requestTrading.put("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), payload);
};
var editStopOrder = function(orderId) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", requestTrading.patch("/smart-order/stop-order/v1/order/".concat(orderId), data));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * @deprecated use deleteStopOrder instead
 */ var smartOrderDelete = function(payload) {
    return requestTrading.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: payload
    });
};
var deleteStopOrder = function(orderId) {
    return requestTrading.delete("".concat(API_TRADING_URL_V2, "/smart-order/stop-order/v1/order/").concat(orderId));
};
var getStockData = function(payload) {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        params: payload
    });
};
var postSmartOrderTnC = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_TRADING_URL_V2 */ .cu, "/smart-order/tnc"), payload);
};


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/orderbook.ts
var orderbook = __webpack_require__(83384);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
;// CONCATENATED MODULE: ./src/utils/securities/transformVirtualTradingData.ts


var vtOrderList = function(data) {
    return data.map(function(item) {
        return {
            action: item.action,
            amount_fee: item.amount.fee,
            amount_invested: item.amount.invested,
            amount_matched: item.amount.matched,
            currency: item.currency,
            gtc: item.gtc.enable ? 1 : 0,
            gtc_expired: item.gtc.expired,
            gtc_status: item.gtc.status,
            order_done: item.done,
            order_open: item.open,
            order_total: item.total,
            orderid: item.id,
            market_orderid: item.market_order_id,
            price: item.price,
            price_average: item.price_average,
            status: item.status,
            symbol: item.symbol,
            time: item.time.created,
            time_open: item.time.open,
            time_match: item.time.match,
            total: item.total,
            platform_order_type: item.platform_order_type,
            smart_order_bracket_order_child: [],
            smart_order_parent_id: "",
            smart_order_parent_price: 0,
            message: item === null || item === void 0 ? void 0 : item.message
        };
    });
};
var vtPortfolioList = function(data) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        // transform to the legacy schema
        tradingbalance: data.trading_balance,
        amount_invested: data.amount.invested,
        amount_allocated: data.amount.allocated,
        amount_creditlimit: data.amount.credit_limit,
        unrealised_profitloss: data.profit_loss.unrealized,
        realised_profitloss: data.profit_loss.realized,
        profitloss: data.profit_loss.total,
        equity: data.equity,
        gain: data.gain,
        // transform to the legacy schema
        result: data.result.map(function(item) {
            return {
                available_lot: item.available_lot,
                balance_lot: item.balance_lot,
                symbol: item.symbol,
                sell_open: item.sell_open.total,
                sell_open_today: item.sell_open.today,
                total: item.total,
                price: item.price.order,
                price_average: item.price.average,
                price_latest: item.price.market,
                unrealised_marketvalue: item.unrealized.market_value,
                unrealised_profitloss: item.unrealized.profit_loss,
                unrealised_gain: item.unrealized.gain,
                name: item.name
            };
        })
    });
};
/* harmony default export */ var transformVirtualTradingData = ({
    vtOrderList: vtOrderList,
    vtPortfolioList: vtPortfolioList
});

// EXTERNAL MODULE: ./src/global/VirtualTrading/api/order.ts + 1 modules
var order = __webpack_require__(79397);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/portfolio.ts + 1 modules
var portfolio = __webpack_require__(80943);
;// CONCATENATED MODULE: ./src/lib/stores/tradingData.ts
/* eslint-disable import/no-named-as-default-member */ 
















var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var historyDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        data: [],
        page: "1",
        isNeedToFetchMore: false,
        totalRealizedAmount: 0,
        tooltipHeader: "",
        tooltips: []
    },
    showSkeleton: true
});
var transactionHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        history: []
    },
    showSkeleton: false
});
var portfolioDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        tradingbalance: 0,
        amount_invested: 0,
        amount_allocated: 0,
        unrealised_profitloss: 0,
        gain: 0,
        equity: 0,
        result: [],
        auto_order_info: "",
        // Day Trade
        day_trade: [],
        debt_ratio: 0,
        debt_total: 0,
        debt_market_value: 0
    }
});
var portfolioDetailDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_lot: 0,
        available_share: 0,
        exercise_data: {
            price: 0
        }
    }
});
var cashOnHandDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_cash_on_hand: 0
    }
});
var orderHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: []
});
var setIsLoading = function(key, set) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        isLoading: true
    })), false, "setIsLoading/".concat(key));
};
var setError = function(error, key, set) {
    var custom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        error: error
    })), false, "setError/".concat(key));
};
var setData = function(data, message, key, set) {
    var custom = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        data: data,
        message: message
    })), false, "setData/".concat(key));
};
var tradingDataStore = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)((0,middleware/* persist */.tJ)((0,middleware/* subscribeWithSelector */.XR)(function(set, get) {
    return {
        portfolio: portfolioDefault,
        orderHistory: orderHistoryDefault,
        configFormula: defaultData,
        exerciseList: defaultData,
        history: historyDefault,
        transactionHistory: transactionHistoryDefault,
        company: defaultData,
        corpActions: defaultData,
        exercise: defaultData,
        cashOnHand: cashOnHandDefault,
        portfolioDetail: portfolioDetailDefault,
        portfolioDetailDayTrade: portfolioDetailDefault,
        rightTradeable: defaultData,
        stockTradable: defaultData,
        resetModalData: function() {
            set({
                rightTradeable: defaultData,
                exercise: defaultData,
                cashOnHand: cashOnHandDefault
            });
        },
        resetCompany: function() {
            set({
                company: defaultData
            });
        },
        setSkeleton: function(key, showSkeleton) {
            set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get()[key]), {
                showSkeleton: showSkeleton
            })));
        },
        getPortfolio: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, responseData, message, data, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "portfolio";
                            if (resetData) setIsLoading(key, set, portfolioDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? portfolio/* getPortfolioList */.g : trade/* default.getPortfolio */.Z.getPortfolio;
                            _ctx.next = 7;
                            return api();
                        case 7:
                            response = _ctx.sent;
                            if (!(response.data.error || !response.data)) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to get portfolio failed";
                            setError(_$error, key, set, portfolioDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, responseData = _data.data, message = _data.message;
                            data = isRealTrading ? transformData/* default.portfolioList */.ZP.portfolioList(responseData) : transformVirtualTradingData.vtPortfolioList(responseData);
                            setData(data, message, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getConfigFormula: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, persistedFormula, response, _$error, _data, responseData, message, data, formulaStockbit;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "configFormula";
                        persistedFormula = get().configFormula;
                        setIsLoading(key, set, persistedFormula);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return trade/* default.getConfigFormula */.Z.getConfigFormula();
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _$error = "Attempt to retrieve config formula failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 11:
                        _data = response.data, responseData = _data.data, message = _data.message;
                        data = transformData/* default.formulaData */.ZP.formulaData(responseData);
                        formulaStockbit = {
                            formula: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.formula), {
                                fee_buy: data.fee.buy,
                                fee_sell: data.fee.sell,
                                fee_buy_day_trade: data.day_trade.fee.buy,
                                fee_sell_day_trade: data.day_trade.fee.sell
                            })
                        };
                        localStorage.setItem("formulaStockbit", JSON.stringify(formulaStockbit));
                        localStorage.setItem("securitiesPreviewFeeData", JSON.stringify(data.preview_fee));
                        localStorage.setItem("securitiesPreviewFeeDataDayTrade", JSON.stringify(data.day_trade.preview_fee));
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formulaStockbit), {
                            preview_fee: data.preview_fee,
                            day_trade: data.day_trade
                        }), message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](3);
                        setError(_ctx.t0, key, set, persistedFormula);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    21
                ]
            ]);
        })),
        getOrderHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, data, message, result, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "orderHistory";
                            if (resetData) setIsLoading(key, set, orderHistoryDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? order/* getVirtualOrderList */.cf : trade/* default.getOrderList */.Z.getOrderList;
                            _ctx.next = 7;
                            return api(0);
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to retrieve order history failed";
                            setError(_$error, key, set, orderHistoryDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = isRealTrading ? transformData/* default.orderList */.ZP.orderList(data) : transformVirtualTradingData.vtOrderList(data);
                            setData(result, message, key, set);
                            store/* default.getState */.Z.getState().searchAndFilter(result);
                            return _ctx.abrupt("return", {
                                data: result,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, orderHistoryDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExerciseList: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "exerciseList";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getExerciseList */.Z.getExerciseList();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to retrieve exercise list failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var filters, appendData, key, oldData, response, _$error, _data, data, message, _$error1, ref, page, updatedData, oldData1, transformedHistoryData, isGroupDateExistOnPrevPage, newData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            filters = param.filters, appendData = param.appendData;
                            key = "history";
                            if (Number(filters.page) > 1) {
                                oldData = get().history;
                                set({
                                    history: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldData), {
                                        isLoading: true
                                    })
                                });
                            } else {
                                setIsLoading(key, set, historyDefault);
                            }
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getHistory */.Z.getHistory(filters);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (!_$error1) {
                                _ctx.next = 15;
                                break;
                            }
                            setError(_$error1, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            throw new Error(_$error1);
                        case 15:
                            if (data) {
                                ;
                                page = (filters === null || filters === void 0 ? void 0 : filters.page) || 1;
                                updatedData = [];
                                oldData1 = (ref = get().history.data) === null || ref === void 0 ? void 0 : ref.data;
                                if (data === null || data === void 0 ? void 0 : data.history) {
                                    transformedHistoryData = data.history.reduce(function(prev, curr) {
                                        var _prev;
                                        var isMonthlyRealizedAvailable = typeof curr === "object" && "monthly_gain" in curr;
                                        (_prev = prev).push.apply(_prev, [
                                            (0,_object_spread/* default */.Z)({
                                                groupDate: curr.date
                                            }, isMonthlyRealizedAvailable ? {
                                                groupRealizedGain: curr.monthly_gain
                                            } : {
                                                groupRealizedGain: null
                                            }), 
                                        ].concat((0,_to_consumable_array/* default */.Z)(curr.history_list)));
                                        return prev;
                                    }, []);
                                    if (appendData && oldData1.length && transformedHistoryData.length) {
                                        isGroupDateExistOnPrevPage = (oldData1 === null || oldData1 === void 0 ? void 0 : oldData1.find(function(item) {
                                            var ref;
                                            return item.groupDate === ((ref = transformedHistoryData[0]) === null || ref === void 0 ? void 0 : ref.groupDate);
                                        })) || null;
                                        if (isGroupDateExistOnPrevPage) {
                                            transformedHistoryData.shift();
                                        }
                                        updatedData = (0,_to_consumable_array/* default */.Z)(oldData1).concat((0,_to_consumable_array/* default */.Z)(transformedHistoryData));
                                    } else {
                                        updatedData = transformedHistoryData;
                                    }
                                } else if (appendData && oldData1) {
                                    updatedData = oldData1;
                                }
                                newData = {
                                    data: updatedData,
                                    page: page,
                                    isNeedToFetchMore: page < data.meta.max_page,
                                    totalRealizedAmount: data.meta.total_realized_amount,
                                    tooltipHeader: data.meta.tooltip_header,
                                    tooltips: data.meta.tooltips
                                };
                                setData(newData, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                    // @ts-ignore
                                    showSkeleton: false
                                }));
                            }
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         *
         * TODO | SBPD-9819
         * Migrate to use the getHistory API
         * - [ ] Adjust the @params to match /history API
         * - [ ] Adjust the response of the /history
         * - [ ] Transform the response to the legacy UI
         * - [ ] Test
         */ getTransactionHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(urlParams) {
                var key, response, _$error, _data, data, message, _$error1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "transactionHistory";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getHistory */.Z.getHistory(urlParams);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (_$error1) {
                                setError(_$error1, key, set, {
                                    // @ts-ignore -- TODO:  Fix the type of the store interface
                                    // current implementation has too many instances
                                    // where the types are casted using 'any'
                                    // makes it difficult to achieve static typing
                                    showSkeleton: false
                                });
                            }
                            setData(data, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore -- Same as above
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", response.data);
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(urlParams) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCompany: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "company";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return orderbook/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCorpActions: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbols) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "corpActions";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return securities/* default.getAllCorpAction */.Z.getAllCorpAction(symbols);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbols) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "exercise";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getExercise */.Z.getExercise(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        checkRightTradeable: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "rightTradeable";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.checkRightTradeable */.Z.checkRightTradeable();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to post trade buy failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, keyDetail, response, _$error, _data, data, message, result, dayTrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "portfolioDetail";
                            keyDetail = "portfolioDetailDayTrade";
                            setIsLoading(key, set, portfolioDetailDefault);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getPortfolioDetail */.Z.getPortfolioDetail(stockCode);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to get portfolio detail failed";
                            setError(_$error, key, set, portfolioDetailDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = transformData/* default.portfolioItem */.ZP.portfolioItem(data.result);
                            dayTrade = transformData/* default.portfolioItem */.ZP.portfolioItem(data.day_trade);
                            setData(result, message, key, set, portfolioDetailDefault);
                            setData(dayTrade, message, keyDetail, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                data: {
                                    result: result,
                                    day_trade: dayTrade
                                },
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCashOnHand: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "cashOnHand";
                        setIsLoading(key, set, cashOnHandDefault);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getCashOnHand */.Z.getCashOnHand();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to get cash on hand failed";
                        setError(_$error, key, set, cashOnHandDefault);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        // Live Portfolio - LivePrice
        updatePortfolioListItem: function(stockCode, newData) {
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var price_latest = newData.price_latest;
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var persistedFormula = get().configFormula;
            if (!(persistedFormula === null || persistedFormula === void 0 ? void 0 : persistedFormula.data)) return;
            // Update portfolio list item (Table) - Regular
            var resultList = (ref1 = portfolioData.result) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            var dayTradeList = (ref2 = portfolioData.day_trade) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            // Update portfolio summary (Header) - Live Price
            // Update portfolio summary (Header)
            var ref3 = (0,formula/* generateUpdatedPortfolioHeader */.Oz)(persistedFormula.data, resultList, dayTradeList, portfolioData.tradingbalance, portfolioData.amount_invested, portfolioData.amount_allocated, portfolioData.debt_total), unrealised_profitloss = ref3.unrealised_profitloss, gain = ref3.gain, equity = ref3.equity, ratio = ref3.ratio, market_value = ref3.market_value;
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData), {
                result: resultList,
                day_trade: dayTradeList,
                unrealised_profitloss: unrealised_profitloss,
                gain: gain,
                equity: equity,
                debt_ratio: ratio,
                debt_market_value: market_value
            }), "update-portfolio-liveprice", key, set, portfolioDefault);
        },
        // End Live Portfolio - LivePrice
        // Live Portfolio - New WS
        updatePortfolioSummary: function(newData) {
            var ref;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            setData((0,_object_spread/* default */.Z)({}, portfolioData, newData), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioList: function(newData) {
            var ref;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var resultList = newData.result.map(function(item) {
                var ref;
                var oldItem = (ref = portfolioData.result) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            var dayTradeList = newData.day_trade.map(function(item) {
                var ref;
                var oldItem = (ref = portfolioData.day_trade) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData, newData), {
                result: resultList,
                day_trade: dayTradeList
            }), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioItem: function(stockCode, newData) {
            var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var portfolioDetailData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioDetailData || !newData) return;
            var portfolioList = isDayTrade ? portfolioDetailData.day_trade : portfolioDetailData.result;
            if (!portfolioList) return;
            // Update portfolio detail if exist
            var resultList = portfolioList.map(function(item) {
                if (item.symbol === stockCode) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new portfolio detail if not exist
            var isPortfolioExist = portfolioList.find(function(item) {
                return item.symbol === stockCode;
            });
            if (!isPortfolioExist && resultList) {
                resultList.push(newData);
                resultList.sort(function(a, b) {
                    var symbolA = a.symbol.toUpperCase();
                    var symbolB = b.symbol.toUpperCase();
                    if (symbolA < symbolB) {
                        return -1;
                    }
                    if (symbolA > symbolB) {
                        return 1;
                    }
                    return 0;
                });
            }
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioDetailData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
            // update portfolioDetail if exist
            var portfolioDetail = isDayTrade ? (ref1 = get().portfolioDetailDayTrade) === null || ref1 === void 0 ? void 0 : ref1.data : (ref2 = get().portfolioDetail) === null || ref2 === void 0 ? void 0 : ref2.data;
            if (!portfolioDetail) return;
            if (portfolioDetail.symbol === stockCode) {
                var keyDetail = isDayTrade ? "portfolioDetailDayTrade" : "portfolioDetail";
                setData((0,_object_spread/* default */.Z)({}, portfolioDetail, newData), "update-portfolio-detail-ws", keyDetail, set);
            }
        },
        deletePortfolioItem: function(stockCode) {
            var isDayTrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref, ref1, ref2, ref3, ref4;
            if (!stockCode) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var portfolioList = isDayTrade ? (ref1 = get().portfolio) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.day_trade : (ref3 = get().portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.result;
            if (!portfolioList) return;
            var resultList = portfolioList.filter(function(item) {
                return item.symbol !== stockCode;
            });
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
        },
        updateOrderList: function(newData) {
            var ref;
            if (!newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var orderList = newData.map(function(item) {
                var oldItem = orderHistoryData.find(function(res) {
                    return res.orderid === item.orderid;
                });
                if (!oldItem) return item;
                return (0,_object_spread/* default */.Z)({}, oldItem, item);
            });
            if ((orderList === null || orderList === void 0 ? void 0 : orderList.length) === 0) return;
            setData(orderList, "update-order-list-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(orderList);
        },
        updateOrderListItem: function(orderId, newData) {
            var ref, ref1;
            if (!orderId || !newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            var orderHistoryLoading = (ref1 = get().orderHistory) === null || ref1 === void 0 ? void 0 : ref1.isLoading;
            if (!orderHistoryData) return;
            // Update order detail if exist
            var resultList = orderHistoryData.map(function(item) {
                if (item.orderid === orderId) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new order detail if not exist
            var isOrderExist = orderHistoryData.find(function(item) {
                return item.orderid === orderId;
            });
            // only update order list if order list is not empty and not loading
            if ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.length) === 0 && orderHistoryLoading) return;
            if (!isOrderExist) {
                resultList.unshift(newData);
            }
            setData(resultList, "update-order-item-ws", key, set, orderHistoryDefault);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        deleteOrderListItem: function(orderId) {
            var ref;
            if (!orderId) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var resultList = orderHistoryData.filter(function(item) {
                return item.orderid !== orderId;
            });
            setData(resultList, "delete-order-item-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        // End Live Portfolio - New WS
        checkStockTradable: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message, tradableData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "stockTradable";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.checkStockTradable */.Z.checkStockTradable(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to check stock tradable failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            tradableData = data[0];
                            setData(tradableData, message, key, set);
                            return _ctx.abrupt("return", {
                                data: tradableData,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }()
    };
}), {
    name: "zustandStockbitFormula",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            configFormula: state.configFormula
        };
    }
})));
/* harmony default export */ var tradingData = (tradingDataStore);


/***/ }),

/***/ 31532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingOperation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/alert.ts
var api_alert = __webpack_require__(56703);
// EXTERNAL MODULE: ./src/lib/api/smartOrder.ts
var smartOrder = __webpack_require__(59140);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/config.ts + 1 modules
var config = __webpack_require__(86408);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/types/transactions.ts
var VirtualExpiryId;
(function(VirtualExpiryId) {
    VirtualExpiryId[VirtualExpiryId["GoodForDay"] = 0] = "GoodForDay";
    VirtualExpiryId[VirtualExpiryId["GoodTillCanceled"] = 1] = "GoodTillCanceled";
})(VirtualExpiryId || (VirtualExpiryId = {}));

;// CONCATENATED MODULE: ./src/lib/stores/tradingOperation.ts
/* eslint-disable import/no-named-as-default-member */ 










var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var setIsLoading = function(key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        isLoading: true
    })));
};
var setError = function(error, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        error: error
    })));
};
var setData = function(data, message, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        data: data,
        message: message
    })));
};
var tradingOperationStore = (0,esm/* default */.ZP)(function(set) {
    return {
        postTradeCancelData: defaultData,
        addPriceAlertData: defaultData,
        postTradeBuyData: defaultData,
        postSmartOrderBuyData: defaultData,
        postTradeSellData: defaultData,
        postTradeAmendData: defaultData,
        postRequestExerciseData: defaultData,
        postDayTradeBuyData: defaultData,
        postDayTradeSellData: defaultData,
        postDayTradeAmendData: defaultData,
        postDayTradeCancelData: defaultData,
        deleteTrailingStopData: defaultData,
        deleteStopOrderData: defaultData,
        deleteBracketOrderData: defaultData,
        postTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, orderkey, symbol, gtc, isRealTrading, key, apiData, apiFunction, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, orderkey = param.orderkey, symbol = param.symbol, gtc = param.gtc, isRealTrading = param.isRealTrading;
                            key = "postTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            apiData = isRealTrading ? {
                                orderid: orderid,
                                orderkey: orderkey,
                                symbol: symbol,
                                gtc: gtc
                            } : {
                                order_id: orderid,
                                gtc: gtc === VirtualExpiryId.GoodTillCanceled
                            };
                            apiFunction = !isRealTrading ? config/* postCancel */.u : trade/* default.tradeCancel */.Z.tradeCancel;
                            _ctx.next = 8;
                            return apiFunction(apiData);
                        case 8:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            setError("Attempt to cancel trade failed", key, set);
                            throw new Error("Attempt to cancel trade failed");
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        addPriceAlert: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var name, command, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            name = param.name, command = param.command;
                            key = "addPriceAlertData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return api_alert/* default.addPriceAlert */.Z.addPriceAlert(name, command);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve exercise list failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(buyData) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.tradeBuy */.Z.tradeBuy(buyData);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(buyData) {
                return _ref.apply(this, arguments);
            };
        }(),
        postSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postSmartOrderBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,smartOrder/* postStopOrder */.xy)(payload);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post smart order failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sellData) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.tradeSell */.Z.tradeSell(sellData);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(sellData) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orders) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.bulkTradeAmend */.Z.bulkTradeAmend(orders);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orders) {
                return _ref.apply(this, arguments);
            };
        }(),
        postRequestExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderKey, shares, stockCode, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderKey = param.orderKey, shares = param.shares, stockCode = param.stockCode;
                            key = "postRequestExerciseData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.postRequestExercise */.Z.postRequestExercise({
                                stockCode: stockCode,
                                shares: shares,
                                orderKey: orderKey
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post request exercise data failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        editSmartOrder: function(orderId) {
            return function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                    var response, _data, data, _$error, errorType, message;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return (0,smartOrder/* editStopOrder */.Ff)(orderId)(payload);
                            case 3:
                                response = _ctx.sent;
                                if (response.data) {
                                    _ctx.next = 6;
                                    break;
                                }
                                throw new Error("Error while fetching data");
                            case 6:
                                _data = response.data, data = _data.data, _$error = _data.error, errorType = _data.error_type, message = _data.message;
                                if (!(_$error || errorType)) {
                                    _ctx.next = 9;
                                    break;
                                }
                                throw new Error(message);
                            case 9:
                                return _ctx.abrupt("return", {
                                    data: data,
                                    message: message
                                });
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](0);
                                return _ctx.abrupt("return", {
                                    error: _ctx.t0
                                });
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            12
                        ]
                    ]);
                }));
                return function(payload) {
                    return _ref.apply(this, arguments);
                };
            }();
        },
        // Day Trade
        postDayTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, multiplier, platform_order_type, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares, multiplier = param.multiplier, platform_order_type = param.platform_order_type;
                            key = "postDayTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeBuy({
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                multiplier: multiplier,
                                platform_order_type: platform_order_type
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, platform_order_type, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares, platform_order_type = param.platform_order_type;
                            key = "postDayTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeSell({
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                platform_order_type: platform_order_type
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, price, shares, multiplier, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, price = param.price, shares = param.shares, multiplier = param.multiplier;
                            key = "postDayTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.dayTradeAmend */.Z.dayTradeAmend({
                                orderid: orderid,
                                price: price,
                                shares: shares,
                                multiplier: multiplier
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post day trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderKey) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postDayTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.dayTradeCancel */.Z.dayTradeCancel(orderKey);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 9;
                                break;
                            }
                            setError("Attempt to cancel day trade failed", key, set);
                            throw new Error("Attempt to cancel day trade failed");
                        case 9:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postDayTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orderKey) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteTrailingStop: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteTrailingStopData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteTrailingStop */.Z.deleteTrailingStop(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to delete trailing stop failed", key, set);
                            throw new Error("Attempt to delete trailing stop failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteStopOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteStopOrderData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteStopOrder */.Z.deleteStopOrder(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to cancel stop order failed", key, set);
                            throw new Error("Attempt to cancel stop order failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        deleteBracketOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderId) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "deleteBracketOrderData";
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return trade/* default.deleteBracketOrder */.Z.deleteBracketOrder(orderId);
                        case 4:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 8;
                                break;
                            }
                            setError("Attempt to cancel bracket order failed", key, set);
                            throw new Error("Attempt to cancel bracket order failed");
                        case 8:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var tradingOperation = (tradingOperationStore);


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "Y4": function() { return /* binding */ numberFormat; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var halfEven = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var roundingFn = number >= 0 ? Math.floor : Math.ceil;
    if (halfEven) roundingFn = Math.round;
    var nNumber = roundingFn(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n) {
    return Number(n) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    if (newNumber === null || newNumber === void 0 ? void 0 : newNumber.toString().startsWith("-")) {
        minus = true;
        newNumber = Math.abs(newNumber);
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(number))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ })

}]);